<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'app'
    }
</script>
<style lang="scss">
    body {
        height: 100%;
        margin: 0;
        padding: 0;
    }
</style>
